import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import PropTypes from 'prop-types';
import TableItem from './TableItem';
import AppTableContainer from '@projectK/components/AppTableContainer';
import AppScrollbar from '@projectK/components/AppScrollbar';
import { TableCell, TableSortLabel, TableRow } from '@mui/material';
import { Fonts } from '@projectK/constants';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import AppTableLoader from '@projectK/components/AppTableLoader';
import AppTableNoData from '@projectK/components/AppTableNoData';
const AuditLogTable = ({
  emailtemplateData,
  loading,
  fetchData,
  createdDateSorting,
  setCreatedDateSorting,
  actionTypeSorting,
  setActionTypeSorting,
  nameSorting,
  setNameSorting,
  userRoleSorting,
  setUserRoleSorting,
  createdUserNameSorting,
  setCreatedUserNameSorting,
  contentSorting,
  setContentSorting,
  actualUserRole,
  setActualUserRole,
  models,
}) => {
  const companyTheme = CompanyTheme();


  const handleSort = (column) => {
    setCreatedDateSorting(column === 'created_at' ? !createdDateSorting : null);
    setActionTypeSorting(
      column === 'action_type' ? !actionTypeSorting : null,
    );
    setNameSorting(column === 'user_name' ? !nameSorting : null);
    setUserRoleSorting(column === 'user_role' ? !userRoleSorting : null);
    setCreatedUserNameSorting(column === 'created_userName' ? !createdUserNameSorting : null);
    setActualUserRole(column === 'actual_userRole' ? !actualUserRole : null);
    setContentSorting(column === 'contents' ? !contentSorting : null);
  };

  return (
    <AppTableContainer className="app-table-container">
     <AppTableLoader loading={loading} className={'app-table-loader'}/>
      <AppScrollbar className='max-h'>
        <Table stickyHeader>
          <TableHead
            sx={{
              borderBottom: '0 none',
              '& .tableCell': {
                fontSize: 13,
                padding: 2,
                fontWeight: Fonts.BOLD,
                backgroundColor: companyTheme
                  ? companyTheme.primary.main
                  : '#211251',
                color: '#ffffff',
                '&:first-of-type': {
                  pl: 5,
                },
                '&:last-of-type': {
                  pr: 5,
                },
              },
            }}
          >
            <TableRow>
              <TableCell className='tableCell'>
                <TableSortLabel
                  active={actionTypeSorting}
                  direction={actionTypeSorting ? 'asc' : 'desc'}
                  onClick={() => handleSort('action_type')}
                >
                  Action Type
                </TableSortLabel>
              </TableCell>
              <TableCell className='tableCell' align='left'>
                <TableSortLabel
                  active={nameSorting}
                  direction={nameSorting ? 'asc' : 'desc'}
                  onClick={() => handleSort('user_name')}
                >
                  User Name
                </TableSortLabel>
              </TableCell>
              <TableCell className='tableCell'>
                <TableSortLabel
                  active={userRoleSorting}
                  direction={userRoleSorting ? 'asc' : 'desc'}
                  onClick={() => handleSort('user_role')}
                >
                  User Role
                </TableSortLabel>
              </TableCell>
              <TableCell className='tableCell'>
                <TableSortLabel
                  active={createdUserNameSorting}
                  direction={createdUserNameSorting ? 'asc' : 'desc'}
                  onClick={() => handleSort('created_userName')}
                >
                  Actual user
                </TableSortLabel>
              </TableCell>
              <TableCell className='tableCell'>
                <TableSortLabel
                  active={actualUserRole}
                  direction={actualUserRole ? 'asc' : 'desc'}
                  onClick={() => handleSort('actual_userRole')}
                >
                  Actual user role
                </TableSortLabel>
              </TableCell>
              <TableCell className='tableCell' align='left'>
                <TableSortLabel
                  active={contentSorting}
                  direction={contentSorting ? 'asc' : 'desc'}
                  onClick={() => handleSort('contents')}
                >
                  Model
                </TableSortLabel>
              </TableCell>
              <TableCell className='tableCell' align='left'>
                <TableSortLabel
                  active={createdDateSorting}
                  direction={createdDateSorting ? 'asc' : 'desc'}
                  onClick={() => handleSort('created_at')}
                >
                  Created DateTime
                </TableSortLabel>
              </TableCell>
              <TableCell className='tableCell' align='center'>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
           <TableBody>
             {emailtemplateData.length > 0 ? (
              emailtemplateData.map((data, index) => (
                <TableItem
                  data={data}
                  key={data.id}
                  fetchData={fetchData}
                  models={models}
                />
              ))
             ) : (
             <AppTableNoData
               colSpan={8}
               message="No Audit Log Found"
               loading={loading}
               />
              )}
           </TableBody>
        </Table>
      </AppScrollbar>
    </AppTableContainer>
  );
};

AuditLogTable.propTypes = {
  emailtemplateData: PropTypes.array,
  loading: PropTypes.bool,
  fetchData: PropTypes.func,
  createdDateSorting: PropTypes.bool,
  setCreatedDateSorting: PropTypes.func,
  actionTypeSorting: PropTypes.bool,
  setActionTypeSorting: PropTypes.func,
  nameSorting: PropTypes.bool,
  setNameSorting: PropTypes.func,
  userRoleSorting: PropTypes.bool,
  setUserRoleSorting: PropTypes.func,
  createdUserNameSorting: PropTypes.bool,
  setCreatedUserNameSorting: PropTypes.func,
  contentSorting: PropTypes.bool,
  setContentSorting: PropTypes.func,
  actualUserRole: PropTypes.bool,
  setActualUserRole: PropTypes.func,
  models: PropTypes.array,
};

export default AuditLogTable;
